module.exports = __webpack_public_path__ + "static/media/next-icon-torizara-o.f2d1c92e.svg";